import { useState, useEffect } from 'react'
import MultiChoices from "./MultiChoices";
import OpenEndedQuestion from "./OpenEndedQuestion";
import Question from "../assets/Question.png";
import multi_choices from "../assets/multi_choices.jpg";


export default function AddQuestions({
  questions, videoRef, setQuestions, hitQuestion, setIsPlaying,
  onProgressEvents, setOnProgressEvents
}) {

  const [isPopUpVisiable, setIsPopupVisiable] = useState(false);
  const [isOpenEndedQuestionVisiable, setIsOpenEndedQuestionVisiable] = useState(false);
  const [isMutiChoicesVisiable, setIsMutiChoicesVisiable] = useState(false);
  const [progressTime, setProgressTime] = useState("00:00");
  const [currentTimeInSec, setCurrentTimeInsec] = useState(0);
  const handleOpenEndedQuestion = () => {
    setIsOpenEndedQuestionVisiable(!isOpenEndedQuestionVisiable);
    setIsPopupVisiable(false);

  }
  const handleMutiChoicesQuestion = () => {
    setIsMutiChoicesVisiable(!isMutiChoicesVisiable);
    setIsPopupVisiable(false);

  }
  const handleOpenOuterModal = () => {
    setIsPopupVisiable(true);
    setIsPlaying(false);
    const video = videoRef.current;
    video.id == 'video' && video.pause();
  }

  const handleCloseOuterModal = () => {
    setIsPopupVisiable(false);
  }
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video?.id == 'video') {
      const handleTimeUpdate = () => {
        setProgressTime(formatTime(video.currentTime))
        setCurrentTimeInsec(video.currentTime);
      };
      video.addEventListener('timeupdate', handleTimeUpdate);

      return () => {
        video.removeEventListener('timeupdate', handleTimeUpdate);
      };
    } else {
      const handleTimeUpdate = () => {
        setProgressTime(formatTime(video.getCurrentTime()))
        setCurrentTimeInsec(video.getCurrentTime());
      };
      !onProgressEvents.some(func => func.toString() == handleTimeUpdate.toString()) &&
        setOnProgressEvents([...onProgressEvents, handleTimeUpdate])
    }

  }, []);

  return (
    <>
      <button onClick={handleOpenOuterModal} type="button" className="btn btn-primary add-activity btn-sm" disabled={hitQuestion}>
        Add Question at {progressTime}
      </button>

      {
        isPopUpVisiable && (
          <div className="modal opacity-100" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" > Add Activity </h5>
                  <button onClick={handleCloseOuterModal} type="button" className="btn-close" ></button>
                </div>
                <div className="modal-body">
                  <div className="content">
                    <button onClick={handleMutiChoicesQuestion} type="button" className={`question-button`}  >
                      <img src={multi_choices} alt="Icon" />
                      <p> Multi Choices Question  </p>

                    </button>
                    <button onClick={handleOpenEndedQuestion} type="button" className={`question-button`}  >
                      <img src={Question} alt="Icon" />
                      <p> Open Ended Question  </p>

                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )
      }

      {
        isMutiChoicesVisiable &&
        <MultiChoices
          questions={questions} setQuestions={setQuestions}
          currentTimeInSec={currentTimeInSec}
          isMutiChoicesVisiable={isMutiChoicesVisiable} setIsMutiChoicesVisiable={setIsMutiChoicesVisiable}
        />
      }

      {
        isOpenEndedQuestionVisiable &&
        <OpenEndedQuestion
          questions={questions} setQuestions={setQuestions}
          currentTimeInSec={currentTimeInSec}
          isOpenEndedQuestionVisiable={isOpenEndedQuestionVisiable} setIsOpenEndedQuestionVisiable={setIsOpenEndedQuestionVisiable}
        />
      }

      {(isPopUpVisiable) && (<div className="modal-backdrop show"></div>)}
    </>
  )
}


